import request from '@/utils/request';

// 新增或修改拉新配置
export function saveOrUpdateUserInviteConfig(data) {
  return request({
    url: '/config/saveOrUpdateUserInviteConfig',
    method: 'POST',
    data
  });
}
// 获取拉新配置数据
export function fetchUserInviteConfigDetail(data) {
  return request({
    url: '/config/fetchUserInviteConfigDetail',
    method: 'POST',
    data
  });
}
// 拉新记录列表
export function queryMinAppUserInviteLogPageList(data) {
  return request({
    url: '/min/app/user/invite/log/queryMinAppUserInviteLogPageList',
    method: 'POST',
    data
  });
}
// 订单导出Excel
export function orderExportExcel(data) {
  return request({
    url: '/min/app/user/invite/log/exportMinAppUserInviteLog',
    method: 'POST',
    data,
    responseType: 'blob'
  });
}
// 处理用户拉新记录
export function processUserInviteLog(data) {
  return request({
    url: '/min/app/user/invite/log/processUserInviteLog',
    method: 'POST',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/lx.js